
/* eslint-disable */
const state = {
  cashiers:[],
  cashier:{},
  cashierTransactions:[]
}
export default state
